import BuildIcon from '@mui/icons-material/Build';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CreateRepairJobButtonProps } from './CreateRepairJobButton.props';
import { useOpenRepairJob } from './useOpenRepairJob';
import { ActionPermissions } from '../../../@types';
import { isUserHasPermission } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { Button, ButtonColorProps, ButtonVariantProps } from '../../atoms/Button';

const PLACEHOLDER_WIDTH = 190;
const PLACEHOLDER_HEIGHT = 36;

export const CreateRepairJobButton: React.FC<CreateRepairJobButtonProps> = ({ serial, partId }) => {
  const navigate = useNavigate();
  const { data: permissions } = useGetUserSystemPermissions();
  const canCreate = isUserHasPermission(ActionPermissions.Service_Create, permissions);

  const { openRepairJob, isLoading } = useOpenRepairJob(partId);

  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        width={PLACEHOLDER_WIDTH}
        height={PLACEHOLDER_HEIGHT}
        aria-label="Checking for open repair job"
      />
    );
  }

  if (openRepairJob) {
    return (
      <Button
        variant={ButtonVariantProps.Secondary}
        color={ButtonColorProps.Warning}
        startIcon={<BuildIcon />}
        onClick={() => navigate(`/services/${openRepairJob.id}`)}
      >
        Go To Open Repair Job
      </Button>
    );
  }

  if (!canCreate) {
    return null;
  }

  const handleClick = () => {
    const query = serial ? `?serial=${encodeURIComponent(serial)}` : '';
    navigate(`/parts/createRepair${query}`);
  };

  return (
    <Button
      variant={ButtonVariantProps.Secondary}
      color={ButtonColorProps.Primary}
      startIcon={<BuildIcon />}
      onClick={handleClick}
    >
      Create Repair Job
    </Button>
  );
};
